/*
 * @Author: jikeychang@gmail.com
 * @Date: 2021-03-03 17:24:02
 * @LastEditors: JikeyChang
 * @LastEditTime: 2022-11-04 11:38:29
 * @Description: 人员管理、组织管理需要放在vuex的数据模块中
 */
import db from '@/api/feishu/index'; // 对应api-js路径

export default {
  namespaced: true,
  state: {
    // ecarx外部组织
    extraDeptList: [],
    // 部门列表数据
    deptList: [],
    // 用户详情数据
    userData: {}
  },
  actions: {
    // 获取外部部门树
    getEcarxExternalTree({ commit }, param) {
      return db.getEcarxExternalTree(param).then(content => {
        commit('setEcarxExternalTree', content);
      });
    },
    // 获取部门列表
    getDeptListTree({ commit }, param) {
      return db.getDeptListTree(param).then(content => {
        commit('setDeptListTree', content);
      });
    },
    getUserInfo({ commit }, param) {
      commit('setUserInfo', {});
      return db.getUserInfo(param).then(content => {
        commit('setUserInfo', content);
      });
    }
  },
  mutations: {
    setEcarxExternalTree(state, content) {
      const { list } = content;
      state.extraDeptList = list || [];
    },
    setDeptListTree(state, content) {
      const { list } = content;
      state.deptList = list;
    },
    // 用户详情数据
    setUserInfo(state, content) {
      const { data } = content;
      state.userData = data || {};
    }
  }
};
